import { Subscription } from 'rxjs';
import { Component, ViewChild, ElementRef, OnInit, OnDestroy, Input } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { Publication } from '../../../interfaces/publication';
import { PublicationService } from '../../../services/publication.service';
import { Router, NavigationStart, RouterEvent, NavigationEnd } from '@angular/router';
import { User } from '../../../interfaces/user';

import { MenuService } from '../../../services/menu.service';
import { OverlayService } from '../../../services/overlay.service';
import { AdBlockDetectorService } from '../../../services/ad-block-detector.service';
import { ModalDefinition } from '../../../services/overlay.service';
import { LocationService } from '../../../services/location.service';
declare let window: any;

@Component({
	selector: 'bb-navigation',
	templateUrl: './bb-navigation.component.html',
	styleUrls: ['./bb-navigation.component.scss']
})

export class BbNavigationComponent implements OnInit, OnDestroy {
	@Input('publicationConfig') publicationConfig: Publication;
	@ViewChild('search') searchInput: ElementRef;

	adServicesRight: boolean;
	mediaclipsRight: boolean;
	analyticsRight: boolean;

	publication: Publication;
	environment: string;

	userInfo: User;
	showUserinfo: boolean;
	displayName: string;

	adBlocker: boolean;

	menuActive: string;
	openMenu: string;

	showMobileMenu: boolean;

	searchString: string;
	hasPublication: boolean;

	whitelabelLogo: string;

	firstTimeChat = true;
	hsChatOpen = false;

	subscriptions = new Subscription();

	constructor(
		private authenticationService: AuthenticationService,
		private publicationService: PublicationService,
		private router: Router,
		private locationService: LocationService,
		private adBlockDetectorService: AdBlockDetectorService,
		private menuService: MenuService,
		private overlayService: OverlayService
	) {
		this.adServicesRight = false;
		this.mediaclipsRight = false;
		this.analyticsRight = false;

		this.hasPublication = false;

		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			this.publication = publication as Publication;

			this.hasPublication = false;
			if (this.publication) {
				this.hasPublication = true;
			}
		}));

		this.adBlockDetectorService.adBlocker.subscribe((adBlocker: boolean) => {
			this.adBlocker = adBlocker;
		});

		this.showUserinfo = false;
		this.subscriptions.add(this.authenticationService.getUser().subscribe((userInfo: User) => {
			this.userInfo = userInfo;
			this.displayName = '';
			if (userInfo && userInfo.name) {
				this.displayName = userInfo.name;
			}

			this.authenticationService.hasPermission('ad services').subscribe(hasRight => this.adServicesRight = hasRight);
			this.authenticationService.hasPermission('mediaclips').subscribe(hasRight => this.mediaclipsRight = hasRight);
			this.authenticationService.hasPermission('analytics').subscribe(hasRight => this.analyticsRight = hasRight);
		}));

		this.subscriptions.add(this.router.events.subscribe((event: RouterEvent) => {
			if (event instanceof NavigationStart) {
				if (this.router.url !== event.url) {
					this.hideMobileMenu();
				}
			} else if (event instanceof NavigationEnd) {
				this.menuActive = this.mainMenuLink(this.router.url);
			}
		}));

		this.menuActive = this.mainMenuLink(this.router.url);

		this.subscriptions.add(this.menuService.mobileMenu.subscribe((showMobileMenu: boolean) => {
			this.showMobileMenu = showMobileMenu;
			this.adBlockDetectorService.detectAdBlocker();
		}));
	}

	mainMenuLink(url: string): string {
		return url.slice(1).split('/')[0];
	}

	ngOnInit() {
		this.environment = this.locationService.getEnvironment();

		if (this.publicationConfig.whitelabelLogoId && this.publicationConfig.whitelabelLogoId.length) {
			this.whitelabelLogo = 'https:' + this.publicationConfig.server + '/mediaclip/' + this.publicationConfig.whitelabelLogoId + '/pthumbnail/40/40';
		}
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	hideMobileMenu() {
		this.showMobileMenu = false;
	}

	setOpenMenu(menuName: string) {
		this.openMenu = menuName;
	}

	showUserMenu(show: boolean) {
		this.showUserinfo = show;
	}

	doSearch() {
		if (this.searchString?.length > 0) {
			this.router.navigateByUrl('/library/mediaclips?q=' + this.searchString);
			this.searchString = '';

			if (this.searchInput) {
				// Hide mobile keyboard
				this.searchInput.nativeElement.blur();
			}
			this.hideMobileMenu();
		}
	}

	showAbout() {
		const modal: ModalDefinition = {
			icon: '',
			title: '',
			component: { name: 'bb-about' }
		};

		this.overlayService.createModal(modal);
	}

	openHubspotChat() {
		const hubSpotContainer: HTMLElement = document.querySelector('#hubspot-messages-iframe-container');
		if (this.firstTimeChat) {
			window.HubSpotConversations.widget.load();
			window.HubSpotConversations.widget.open();
			this.firstTimeChat = !this.firstTimeChat;
		} else if (hubSpotContainer) {
			if (this.hsChatOpen) {
				hubSpotContainer.style.setProperty('display', 'none', 'important');
			} else {
				hubSpotContainer.style.removeProperty('display');
			}
		}
		this.hsChatOpen = !this.hsChatOpen;
	}

	closeHubspotChat() {
		const hubSpotContainer: HTMLElement = document.querySelector('#hubspot-messages-iframe-container');
		if (this.hsChatOpen && hubSpotContainer) {
			hubSpotContainer.style.setProperty('display', 'none', 'important');
			this.hsChatOpen = true;
		}
		this.hsChatOpen = !this.hsChatOpen;

	}
}
